import {
  CollapsedPriceDetailsConfig,
  ICartUnlockDealsConfig,
  IMiniCouponsConfig,
  IMiniOffersConfig,
  ProductRackConfig,
  MapPickerRemoteConfig,
  RemoteConfig,
  SkinAnalyzerConfig,
  StickyPricePdpConfig,
  PlpCategoryNudgeConfig,
  CartApiConfig,
} from './types';
import { FREE_SHIPPING } from 'constants/footerLinks';
import { DEFAULT_META } from 'constants/meta';

export const CACHE_KEY = 'REMOTE_CONFIG';
export const IS_IN_HOUSE_HELP_CENTER_ENABLED_SWITCH =
  'isInHouseHelpCenterEnabled';
export const LLM_SOURCE_EVENT = 'llmPlatformAcquisition';

export const GET_REMOTE_CONFIG_URL = () => process.env.REMOTE_CONFIG_URL;

export const defaultCategoryControls = {
  designCode: [],
  pdpImage: [],
  priceWithSize: [],
  productComparison: [],
  sizeInfo: [],
  plpImage: [],
  plpVariants: [],
  imageCarousel: [],
  buyNow: [],
  variantSelectorFashion: [],
  variantSelectorGrooming: [],
};

export const defaultPaymentOffersConfig = {
  enabled: false,
  scrollTimerInSeconds: 2,
  autoScrollEnabled: true,
  gradientColors: ['#FAF9FF', '#F9FEFF'],
};

export const defaultConversationalSearchConfig = {
  csLegalMessage: 'AI can make mistakes. Verify responses with experts.',
  showFeedback: true,
  showFollowUps: true,
  chatExpandButtonText: 'Continue Asking',
  maxNumberOfFollowUps: 4,
  loaderUrl: '',
};

export const DEFAULT_SAVINGS_SHELF_CONFIG = {
  nextBestCouponEnabled: true,
  shouldPrioritizeBrandFundedCoupon: true,
};

export const DEFAULT_CART_FREE_GIFT_BANNER = {
  pickGiftBgImage:
    'https://images-static.naikaa.com/media/wysiwyg/uiTools/2025-3/0-corner-radius.png',
  giftCardBgImage:
    'https://images-static.naikaa.com/media/wysiwyg/uiTools/2025-3/corner-radius-7.png',
  borderColor: '#FFE4F5',
};

export const DEFAULT_CART_DELIVERY_GROUP_HEADER = {
  nykaaNowLabel: 'Delivery in ',
  standardDeliveryLabel: 'Standard Delivery',
  nykaaNowLogo:
    'https://images-static.naikaa.com/media/wysiwyg/uiTools/2025-8/Nykaa_Now_Logo.svg',
  defaultMaxEddTime: 90,
};

export const DEFAULT_CART_UNLOCK_DEALS_CONFIG: ICartUnlockDealsConfig = {
  dealBackgroundImage:
    'https://images-static.nykaa.com/media/Bg-illustration.png',
  selectSizeImage:
    'https://images-static.nykaa.com/media/select-size-visual.png',
  selectShadeImage:
    'https://images-static.nykaa.com/media/select-shade-visual.png',
  dealContainerTitle: 'Special deals for you',
  specialDealTagUrl:
    'https://images-static.nykaa.com/media/Special-deal-tag.png',
  enableQuickView: true,
  coachMarkDescription:
    'Special deals can’t be clubbed with any other coupons or brand offers',
  sendUnlockDealEligibilityEvent: false,
  isApiEnabled: false,
  priceText: 'current price: ',
};

export const DEFAULT_COLLAPSED_PRICE_DETAILS: CollapsedPriceDetailsConfig = {
  platformFeeMsg: '{fee} platform fee added',
  priveRewardsMsg: 'You will earn {reward_points} reward points with',
  nonPriveRewardsMsg: 'You will earn {reward_points} reward points',
  priveBandConfig: {
    gold: {
      bgImage: 'https://images-static.nykaa.com/media/Rewardpoints-1.png',
      textColor: '#C18B00',
      priveImg: 'https://images-static.nykaa.com/media/goldPriveLogo.png',
    },
    platinum: {
      bgImage: 'https://images-static.nykaa.com/media/Rewardpoints-2.png',
      textColor: '#6658AE',
      priveImg: 'https://images-static.nykaa.com/media/platinumPriveLogo.png',
    },
    silver: {
      bgImage: 'https://images-static.nykaa.com/media/Rewardpoints.png',
      textColor: '#F06C7A',
      priveImg: 'https://images-static.nykaa.com/media/priveLogo.png',
    },
    non_member: {
      bgImage:
        'https://images-static.naikaa.com/media/wysiwyg/uiTools/2026-2/Rewardpoints1.png',
      textColor: '#1C7DFF',
      priveImg: '',
    },
  },
};

export const DEFAULT_MINI_OFFERS_CONFIG: IMiniOffersConfig = {
  bgGradient: 'linear-gradient(230deg, #D1F2D5 -40.12%, #FFF 41.87%)',
  bgIllustration: 'https://images-static.nykaa.com/media/Offer-Branding.png',
  borderColor: '#D3E7DE',
  showDashedBorder: false,
};

export const DEFAULT_STICKY_PRICE_PDP: StickyPricePdpConfig = {
  priority: [
    'nykaaNow',
    'bestPrice',
    'diffPricingV5',
    'pinkBox',
    'priceFluctuation',
    'salePriceTag',
    'socialProof',
  ],
};

export const DEFAULT_MAP_PICKER_CONFIG: MapPickerRemoteConfig = {
  searchPlaceholder: 'Search for your area or building',
  searchOverlayTitle: 'Search for your location',
  centerPinTitle: 'Deliver Here',
  centerPinSubtitle: 'Place pin on your exact location',
  locateMeLabel: 'Locate Me',
  useCurrentLocationLabel: 'Use my current location',
  defaultAddressTitle: 'ADD ADDRESS',
  defaultAddressSubtitle: 'for faster delivery',
  minSearchLength: 4,
  shimmerCount: 8,
  autocompleteDebounceMs: 300,
  defaultZoom: 16,
  countryRestriction: 'in',
};

export const DEFAULT_SKIN_ANALYZER_CONFIG: SkinAnalyzerConfig = {
  queries: [],
};

export const DEFAULT_PRODUCT_RACK_CONFIG: ProductRackConfig = {
  ctaEnabled: false,
  stepperEnabled: false,
};

export const DEFAULT_CART_API_CONFIG: CartApiConfig = {
  status: false,
  enabledPaths: [],
};

export const DEFAULT_PLP_CATEGORY_NUDGE_CONFIG: PlpCategoryNudgeConfig = {
  enabled: true,
  bgGradientColors: [
    {
      color: '#FFE5F2',
      transparency: 1,
    },
    {
      color: '#FFFFFF',
      transparency: 1,
    },
  ],
  textColor: '#008000',
};

export const DEFAULT_LLM_REFERRER_CONFIG = {
  enabled: true,
  patterns: {
    'chatgpt.com': 'chatgpt',
    'perplexity.ai': 'perplexity',
    'gemini.google.com': 'gemini',
    'claude.ai': 'claude',
  },
};

export const DEFAULT_MINI_COUPONS_CONFIG: IMiniCouponsConfig = {
  couponExpireRange: 24,
  showBorder: false,
};

export const FREE_GIFTS_DEFAULT = {
  giftExpireRange: 24,
  giftValidityRange: 365,
  lockIconSrc: '',
  unlockIconSrc: '',
  bgGradient: '',
};

export const DEFAULT_CONFIG: RemoteConfig = {
  switches: {
    [IS_IN_HOUSE_HELP_CENTER_ENABLED_SWITCH]: false,
    redirectionEnabled: false,
    newRatingForm: true,
    appLinkEnabled: true,
    showDeliveryOnPd: true,
    showOffersOnPdp: false,
    showRewardPoints: true,
    showViewSimilar: true,
    internationalMode: false,
    personalizationEnabled: false,
    redirectionList: [
      {
        name: 'NewPDP',
        status: true,
        userPercentage: 100,
        cookieName: 'NEW_PDP',
      },
      {
        name: 'NewHome',
        status: true,
        userPercentage: 5,
        cookieName: 'N_HOM',
      },
    ],
    trackDeviceId: false,
    pdPageBanners: false,
    offerListingEnabled: false,
    mobileNumberMapping: false,
    showUserPortfolio: false,
    fetchWishlistIds: false,
    webOtpAutoRead: false,
    universalBanners: false,
    pinCodeApiDisabled: true,
    experimentV2Enabled: false,
    analyticsV2Enabled: false,
    analyticsLoggingEnabled: false,
    analyticsBatchMigrationLogic: false,
    loadInterFont: false,
    showChatNow: false,
    optimizedImageUrlEnabled: false,
    signupBannerAdplatformEnabled: false,
    appliedFiltersEnabled: false,
    viewTransitionPDPEnabled: false,
    isPdpCtaEnabled: false,
    isPdpNewOffersEnabled: false,
    isBestPriceEnabled: false,
    isNewSimilarEnabled: false,
    isDynamicFooterLinkEnabled: false,
    isMultiCouponsEnabled: false,
    isPersonalCouponsEnabled: false,
    differentialPricingEnabled: false,
    isPriceRevealV5Enabled: false,
    zendeskChatEnabled: false,
    slpRelatedSearchEnabled: false,
    isPdpCollapsibleEnabled: true,
    isPdBreadcrumbEnabled: true,
    isSlugRedirectEnabled: true,
    isOffersDeltaEnabled: false,
    isOrganicGuidesEnabled: false,
    isHlpCtaEnabled: false,
    isCalloutNudgeEnabled: false,
    isBreadcrumbPositionEnabled: false,
    isNewSearchBarEnabled: false,
    isPlpConfigurableNoResultsEnabled: false,
    isBeautyPortfolioEnabled: false,
    isNewPlpEnabled: false,
    dnSwitches: {},
    isPriveTierBenefitsFromApi: false,
    useNewUrlParamsLogic: true,
  },
  configs: {
    redirectionConfig: {
      seconds: 5,
    },
    gamoogaNotifRestriction: {
      status: true,
      data: ['/p/', '/myProfile'],
    },
    dynamicPriceRangeToastConfig: {
      enabled: true,
      timer: 4,
    },
    customersAlsoBought: {
      status: true,
      algorithm: 'coccurence_direct',
    },
    customersAlsoViewed: {
      status: true,
      algorithm: 'coccurence_simple',
    },
    rewardPointsOnSignUp: 2000,
    upiOffer: {
      status: false,
      message: '',
    },
    comparisonDataWidgetType: {
      status: true,
      widgetType: 'more_from_category',
      initialContentHeight: 400,
    },
    priceReveal: {
      active: false,
      productEligibilityActive: false,
    },
    collapsePdConfig: {
      couponSection: {
        title: 'Coupons',
        subTitle: '',
        isOpened: false,
        key: 'coupons',
      },
      offerSection: {
        title: 'Offers',
        subTitle: '',
        isOpened: false,
        key: 'offers',
      },
      comboSection: {
        title: 'Top selling combos',
        subTitle: '',
        isOpened: false,
        key: 'oupons',
      },
      productDetails: {
        title: 'Product Details',
        subTitle: '',
        isOpened: false,
        key: 'productDetailsSection',
      },
      returnSection: {
        title: 'Authenticity & Return Policy',
        subTitle: '',
        isOpened: false,
        key: 'authReturn',
      },
      deliverySection: {
        title: 'Check Delivery Date',
        subTitle: '',
        isOpened: false,
        key: 'deliveryWidget',
      },
      rnrSection: {
        title: 'Ratings & Reviews',
        subTitle: 'verified ratings',
        isOpened: false,
        key: 'ratingReviews',
      },
      highlightsSection: {
        title: 'Highlights',
        subTitle: '',
        isOpened: false,
        key: 'highlights',
      },
    },
    BestPriceSubtitle: 'Save more with discounts on this item',
    maxSearchHistoryCount: 5,
    trendingSearchesToShow: 5,
    storeOptions: {
      status: false,
      backToBeautyText: 'Back to Main Store',
      exploreMoreStores: '',
      stores: [],
      rememberLastStore: false,
      userPercentage: 0,
    },
    contentPolicy: {
      userPercentage: 5,
      headerKey: 'Content-Security-Policy-Report-Only',
      status: false,
      value: '',
      mcpFrameAncestors: [],
    },
    pdpWidgetConfig: {
      status: '1',
      algo: [
        {
          cav: 'p2v_v2',
        },
        {
          cab: 'p2v_v2',
        },
      ],
    },
    hlpWidgetConfig: {
      status: '1',
      algo: [
        {
          cav: 'algo1',
        },
        {
          cab: 'algo1',
        },
      ],
    },
    sortForListing: [
      {
        name: 'popularity',
        key: 'POPULARITY',
      },
      {
        name: 'discount',
        key: 'DISCOUNT',
      },
      {
        name: 'name',
        key: 'NAME',
      },
      {
        name: 'customer top rated',
        key: 'CUSTOMER_TOP_RATED',
      },
      {
        name: 'new arrivals',
        key: 'NEW_ARRIVAL',
      },
      {
        name: 'price: high to low',
        key: 'PRICE_DESC',
      },
      {
        name: 'price: low to high',
        key: 'PRICE_ASC',
      },
    ],
    freeShipping: FREE_SHIPPING,
    homePage: {
      initialInventories: 2,
      eagerLoadImages: 2,
      pageTypeSuffix: { status: false },
    },
    meta: DEFAULT_META,
    guidedSearch: {
      status: false,
      userPercentage: 0,
    },
    searchSuggestionIcons: {
      query: 'https://images-static.nykaa.com/media/wysiwyg/2020/search.svg',
      buying_guide:
        'https://images-static.nykaa.com/media/wysiwyg/2020/buying-guide.svg',
      history: 'https://images-static.nykaa.com/media/wysiwyg/2020/clock.svg',
      trending:
        'https://images-static.nykaa.com/media/wysiwyg/2020/ic-trending.svg',
    },
    AB: {
      deliveryPolicyWidget: {
        status: false,
        userPercentage: 0,
        keyName: 'ab_deliveryPolicyWidget',
      },
      productAttributes: {
        status: false,
        userPercentage: 0,
        keyName: 'ab_product_attributes',
      },
      searchSuggestion: {
        status: false,
        userPercentage: 0,
        keyName: 'ab_newautocomplete_screen',
      },
      guidedSearch: {
        status: false,
        userPercentage: 0,
        keyName: 'ab_guides',
      },
      reviews: {
        status: false,
        userPercentage: 0,
        keyName: 'ab_reviews',
      },
      comboProducts: {
        status: false,
        userPercentage: 0,
        keyName: 'ab_combo',
      },
      sizeChart: {
        status: false,
        userPercentage: 0,
        keyName: 'ab_size_chart',
      },
      vernacular: {
        status: false,
        userPercentage: 0,
        keyName: 'ab_vernacular',
      },
      shippingStrip: {
        status: false,
        userPercentage: 0,
        keyName: 'ab_shippingStrip',
        configs: {
          freeShippingMsg: '',
          CODMsg: '',
          freeShippingCOD: '',
        },
      },
      pdpBanner: {
        status: false,
        userPercentage: 0,
        keyName: 'ab_pdpBanner',
        banner:
          'https://images-static.naikaa.com/media/wysiwyg/2021/product-top-banner-m.png',
      },
      accountMerging: {
        status: false,
        userPercentage: 0,
        keyName: 'ab_accMerge',
      },
      trueCaller: {
        status: false,
        pollingDelay: 1,
        pollingTimout: 30,
        callingTime: 0.6,
        ctaColor: 'E80071',
        ctaTextColor: 'FFFFFF',
        privacyUrl: 'https://www.nykaa.com/privacy-policy/lp',
        tncUrl: 'https://www.nykaa.com/terms-conditions/lp',
      },
      signUpBanner: {
        status: false,
        userPercentage: 0,
        keyName: 'ab_firstSignUp',
        configs: {
          title: 'Get this product for Price_Value',
          description:
            'Sign up & earn 2000 Reward Points & redeem them at checkout for discount',
        },
      },
      pdpCategoryWidget: {
        status: false,
        userPercentage: 0,
        keyName: 'ab_pdpCategoryWidget',
      },
    },
    defaultVariantConfig: {
      status: false,
      config: {
        ids: [],
        categoryLevels: [],
      },
    },
    domains: ['www.nykaa.com', 'www.nykaaman.com'],
    ABV2: [],
    landingPageABConfig: {},
    regionExperimentMap: {},
    analyticsDelayTimer: 1000,
    analyticsExcludedEventNames: [],
    analyticsEventThreshold: 20,
    analyticsLoggingSampleRate: 0.1,
    analyticsSessionExpireInMinutes: 30,
    analyticsSessionMaxDurationInHours: 12,
    analyticsIncrementalTimerInMs: 0,
    analyticsBatchEventPayloadSizeLimitInKB: 0,
    popularSuggestionWidget: {},
    topNavConfig: {
      status: true,
      enabledPages: ['product', 'listing', 'searchListing'],
    },
    sentrySampleRate: 0.3,
    priveConfig: {
      configs: {
        couponEnabled: true,
        imageSliderUrls: {
          'non-prive': [
            'https://images-static.naikaa.com/media/wysiwyg/2022/nonPriveSilverBenefits.png',
            'https://images-static.naikaa.com/media/wysiwyg/2022/nonPriveGoldBenefits.png',
            'https://images-static.naikaa.com/media/wysiwyg/2022/nonPrivePlatinumBenefits.png',
          ],
          silver: [
            'https://images-static.naikaa.com/media/wysiwyg/2022/nonPriveSilverBenefits.png',
            'https://images-static.naikaa.com/media/wysiwyg/2022/nonPriveGoldBenefits.png',
            'https://images-static.naikaa.com/media/wysiwyg/2022/nonPrivePlatinumBenefits.png',
          ],
          gold: [
            'https://images-static.naikaa.com/media/wysiwyg/2022/goldMemSilverBenefits.png',
            'https://images-static.naikaa.com/media/wysiwyg/2022/goldMemGoldBenefits.png',
            'https://images-static.naikaa.com/media/wysiwyg/2022/goldMemPlatinumBenefits.png',
          ],
          platinum: [
            'https://images-static.naikaa.com/media/wysiwyg/2022/platMemSilverBenefits.png',
            'https://images-static.naikaa.com/media/wysiwyg/2022/platMemGoldBenefits.png',
            'https://images-static.naikaa.com/media/wysiwyg/2022/platMemPlatinumBenefits.png',
          ],
        },
        tierAmounts: {
          silver: 2000,
          gold: 5000,
          platinum: 10000,
        },
        bannerImages: {
          nonLoggedIn:
            'https://images-static.nykaa.com/media/wysiwyg/2022/cms/NonLoggedInBanner.png',
          nonPrive:
            'https://images-static.nykaa.com/media/wysiwyg/2022/cms/NonPriveBanner.png',
        },
        faqList: [
          {
            title: 'What is the Nykaa Prive program?',
            description:
              'Nykaa Prive program is our loyalty program designed to provide special benefits to our loyal customers. It is a tiered program with three different tier i.e. Member, Gold & Platinum.  The only thing you need to do is to shop with us for a minimum amount to join our Prive program.',
          },
          {
            title: 'How do I become a part of Nykaa Prive?',
            description:
              'To join our Nykaa Prive program, you only need to spend a minimum of Rs. 1500 with us in the last 365 days.',
          },
          {
            title: 'How do I move to the next tier?',
            description:
              'You only need to keep shopping - spend Rs. 1500 to become Prive Member, Rs. 5000 to become Prive Gold and Rs. 15000 to become Prive Platinum in last 365 days. As soon as you spend any of the above mentioned amount (and once the return period is over), you will be automatically upgraded to the next tier.',
          },
        ],
        faqUrl: {
          mweb: 'https://www.nykaa.com/nykaa-privee-faq',
          app: 'https://www.nykaa.com/nykaa-privee-faq-app?device_family=app',
        },
        tncUrl: {
          mweb: 'https://www.nykaa.com/nykaa-privee-t-and-c',
          app: 'https://www.nykaa.com/nykaa-privee-t-and-c-app?device_family=app',
        },
      },
    },
    listingPriceReveal: {
      isActive: false,
      title: 'Hot Pink Sale Price',
      styles: {},
    },
    signUpNudge: {},
    pdPriceReveal: {
      isActive: false,
      styles: {},
    },
    knowMoreConfig: {
      isActive: false,
    },
    skipInlineWidgetIndex: 4,
    pdRedirectTargetBlockList: [],
    plpRedirectTargetBlockList: [],
    apiQueryParamConfigV2: {},
    homeh1Tag: '',
    userSegmentConfig: {},
    routineService: {},
    cartNudgeConfig: {
      expirationTime: 24,
      message: '',
      cartNudgeTextIoc: {},
      iocValueExpirationTime: 6,
      iocCookieExpiryTime: 365,
    },
    couponOffers: [],
    AfDownloadStripConfig: {
      title: 'Get more discounts on app',
      ctaText: 'Download Now',
    },
    moveHorizontalWidgetType: 'cav',
    accountFooterItems: [],
    productAttrCategories: {
      status: false,
      title: 'Highlights',
      config: {
        categories: [],
      },
    },
    isEarlyAccessDay: {
      active: false,
      priveBands: [],
    },
    ordersRevampUrl: '/my/orders?src=web',
    listingBestPrice: {},
    guidesFilter: {
      tooltipDisableTime: 5000,
      tooltipTotalVisibilityCount: 0,
    },
    newTagsOnPdp: {
      leftTagEnabled: true,
      primaryTagsEnabled: true,
      secondaryTagEnabled: true,
    },
    pdBreadcrumbsTimeout: 100,
    loginBackground: {},
    categoryControls: defaultCategoryControls,
    paymentOffersConfig: defaultPaymentOffersConfig,
    downloadAppPopup: {
      backgroundImage:
        'https://images-static.nykaa.com/media/wysiwyg/uiTools/2025-7/DownloadAppBg.png',
      ctaText: 'Download App',
    },
    mapPickerConfig: DEFAULT_MAP_PICKER_CONFIG,
    exploreAffiliateLinkSharing: {
      enabled: false,
    },
    dnConfigs: {},
    skinAnalyzerConfig: DEFAULT_SKIN_ANALYZER_CONFIG,
    productRackConfig: DEFAULT_PRODUCT_RACK_CONFIG,
    plpCategoryNudgeConfig: DEFAULT_PLP_CATEGORY_NUDGE_CONFIG,
    savingsShelfConfig: DEFAULT_SAVINGS_SHELF_CONFIG,
    cartApiConfig: DEFAULT_CART_API_CONFIG,
    llmReferrerConfig: DEFAULT_LLM_REFERRER_CONFIG,
    buyNow: {
      discountedPriceThreshold: 199,
    },
  },
};
